import React from 'react';
import { BookOpen, ArrowRight } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function ContentBuilderStep({ programmeId, programme, token, headers }) {
  const navigate = useNavigate();

  if (!programmeId) {
    return (
      <div className="text-center py-12">
        <BookOpen className="h-12 w-12 text-zinc-600 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-white mb-2">Save Programme First</h3>
        <p className="text-zinc-400">Complete Step 1 to build content</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="p-4 bg-indigo-500/10 rounded-lg border border-indigo-500/30">
        <p className="text-sm text-indigo-300">
          Build your programme content by creating weeks/months and adding activities. 
          Activities can include AI-generated courses, learning labs, documents, videos, assignments, and more.
        </p>
      </div>

      <div className="text-center py-8">
        <BookOpen className="h-16 w-16 text-indigo-400 mx-auto mb-4" />
        <h3 className="text-xl font-semibold text-white mb-2">Programme Content Builder</h3>
        <p className="text-zinc-400 mb-6 max-w-md mx-auto">
          Create structured content with periods (weeks/months), activities, and various content types including 
          AI-generated courses, documents, videos, and iframe embeds.
        </p>
        <Button
          onClick={() => navigate(`/admin/programmes/${programmeId}/builder`)}
          className="bg-indigo-600 hover:bg-indigo-700 text-white"
        >
          Open Full Content Builder
          <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </div>

      <div className="grid grid-cols-3 gap-4 mt-8">
        <div className="p-4 bg-zinc-800/50 rounded-lg border border-zinc-700 text-center">
          <div className="text-2xl font-bold text-white mb-1">
            {programme?.periods?.length || 0}
          </div>
          <div className="text-sm text-zinc-400">
            {programme?.structure_type === 'months' ? 'Months' : 'Weeks'}
          </div>
        </div>
        <div className="p-4 bg-zinc-800/50 rounded-lg border border-zinc-700 text-center">
          <div className="text-2xl font-bold text-white mb-1">
            {programme?.total_activities || 0}
          </div>
          <div className="text-sm text-zinc-400">Activities</div>
        </div>
        <div className="p-4 bg-zinc-800/50 rounded-lg border border-zinc-700 text-center">
          <div className="text-2xl font-bold text-white mb-1">
            {programme?.total_content_items || 0}
          </div>
          <div className="text-sm text-zinc-400">Content Items</div>
        </div>
      </div>
    </div>
  );
}
